export const SQLITE3MT_CLIENT_BUSY_RETRY_WINDOW_MS = 30_000
export const SQLITE3MT_CLIENT_BUSY_TIMEOUT_MS = 5_000

